import BrandTile from "../../brandDirectoryPage/brandTile.vue";
import ContentManagmentApi from "../../../services/api/contentManagmentApi.js";
import FavoriteAPI from "../../../services/api/favoritesApi.js";

const ContentManagmentApiService = new ContentManagmentApi(),
  FavoriteAPIService = new FavoriteAPI();

export default {
  components: {
    BrandTile,
  },
  data() {
    return {
      brandsList: [],
    };
  },
  methods: {
    getLandingCollection,
    redirect,
  },
  beforeMount() {
    this.getLandingCollection();
  },
};

function redirect(name, id) {
  this.$router.push("/collections/" + name + "/" + id + "/products");
}

function getLandingCollection() {
  ContentManagmentApiService.getTrendingBrands().then((response) => {
    if (this.$session.getUserInfo() && this.$session.getUserInfo().role === "RETAILER") {
      FavoriteAPIService.getFavoriteBrandIds().then((favoriteResponse) => {
        const favoriteBrandIDsList = favoriteResponse.data.brand_ids;
        this.brandsList = response.data.map((brand) => {
          const brandData = {
            id: brand.entity_id,
            thumbnail_image_url: brand.image_url,
            minimum_order_value: brand.mov,
            brand_name: brand.name,
            vanity_url_name: brand.vanity_url_name,
          };
          return {
            ...brandData,
            is_fav: favoriteBrandIDsList.includes(brandData.id),
          };
        });
      });
    } else {
      this.brandsList = response.data.map((brand) => ({
        id: brand.entity_id,
        thumbnail_image_url: brand.image_url,
        minimum_order_value: brand.mov,
        brand_name: brand.name,
        vanity_url_name: brand.vanity_url_name,
      }));
    }
  });
}
